import React from 'react';
import { ExternalLink, H2, NamedLink } from '../../../components';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './SectionKnowMore.module.css';
import classNames from 'classnames';

const SectionKnowMore = props => {
  const { className } = props;

  const intl = useIntl();

  return (
    <div className={classNames(className, css.root)}>
      <H2 className={css.title}>
        <FormattedMessage
          id="ArtistHelpPage.knowMoreTitle"
          values={{ span: msgFragment => <span className={css.primaryColor}>{msgFragment} </span> }}
        />
      </H2>
      <div className={css.belowTitle}>
        <FormattedMessage
          id="ArtistHelpPage.knowMoreBelowTitle"
          values={{ span: msgFragment => <span className={css.bold}>{msgFragment} </span> }}
        />
      </div>
      <p className={css.text}>
        <FormattedMessage id="ArtistHelpPage.knowMoreText" />
      </p>
      <div className={css.links}>
        <ExternalLink
          href={`mailto:${intl.formatMessage({ id: 'General.artistSupportMail' })}`}
          className={css.primaryLink}
        >
          <FormattedMessage id="ArtistHelpPage.shceduleVideoCall" />
        </ExternalLink>
        <ExternalLink
          href="https://music-marmalade.ncoded.xyz/contact"
          className={css.secondaryLink}
        >
          <FormattedMessage id="ArtistHelpPage.contactUs" />
        </ExternalLink>
      </div>
      <div className={css.terms}>
        <FormattedMessage
          id="ArtistHelpPage.termsAndServices"
          values={{ link: link => <NamedLink name="TermsOfServicePage">{link} </NamedLink> }}
        />
      </div>
    </div>
  );
};

export default SectionKnowMore;
